import React from 'react';

const Bard_Get_Started = () => {
  return (
    <div>
      <h1>Bard_Get_Started</h1>
      <p>This is the Bard_Get_Started component.</p>
    </div>
  );
};

export default Bard_Get_Started;
